import AmplifyActions from '../../../state/amplify/Amplify.actions';
import AuthActions from '../../../state/Auth.actions';
import { formatPhoneNumber } from '/b2b/common/helpers/Phone';
import { updateUserAttributes } from '../../../services';

export const update =
    ({ phone }) =>
    dispatch => {
        const params = { phone: formatPhoneNumber(phone) };
        dispatch(AuthActions.updateUserAttributesBegin(params));

        return updateUserAttributes(params)
            .then(response => {
                dispatch(AmplifyActions.updateUserAttributesSuccess(params, response));

                // After successfully updating the phone number, tell Amplify to verify it
                return dispatch(
                    AmplifyActions.nextStep({
                        isSignedIn: false,
                        nextStep: {
                            availableChallenges: ['SMS_MFA'],
                            signInStep: 'CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION',
                        },
                    })
                );
            })
            .catch(error => {
                const { message } = error;
                dispatch(AuthActions.updateUserAttributesFailure(params, error));

                throw message;
            });
    };
